<template>
    <Layout1 title="Check your email!">
      <template slot="form">
        <form @submit.prevent="sendVerificationCode()">
        <div class="form-floating">
          <p class="col_secondary fn14 ln_ht20 fw400">An email with instructions to reset your password has been sent to your email address <strong class="fw700">{{email}}</strong>. Follow the steps in the email to reset your account password.</p>
        </div>
        <div class="mb20 mt20">
          <input type="submit" class="btn btn-apiculus-primary" value="RESEND PASSWORD RESET INSTRUCTIONS" />
        </div>
        </form>
      </template>
    </Layout1>
  </template>
  
  <script>
import helpers from '../../services/toast-service'
  import Layout1 from './Layout1.vue'
  
  export default {
    name: 'resendLink',
    mixins: [helpers],
    data () {
      return {
        email: '',
        color: '',
        message: '',
      }
    },
    components: {
      Layout1
    },
    methods: {
      sendVerificationCode () {
        this.$store.dispatch('ACTION_RESEND_VERIFICATION_LINK', { email: this.email }).then(res => {
          if (!res.success) {
          this.toastAlert(res.error.message || 'Something went wrong.', 'error')
        } else {
          this.toastAlert('Verification email sent, Please check your inbox.', 'success')
        }
      })
      }
    },
    // mounted () {
    //   let userDetails = this.$route.params
    //   if (!(Object.keys(userDetails).length > 0)) {
    //     this.$router.push('/signup2')
    //   } else {
    //     this.email = userDetails.email
    //   }
    // },
    created () {
      this.email = this.$route.query.email
      // this.email = Object.values(this.$route.query).reduce((a,b)=>{
      //   return a+b
      // })
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  